import { render, staticRenderFns } from "./UploadChapter.vue?vue&type=template&id=4cd8b58f&scoped=true"
import script from "./UploadChapter.vue?vue&type=script&lang=js"
export * from "./UploadChapter.vue?vue&type=script&lang=js"
import style0 from "./UploadChapter.vue?vue&type=style&index=0&id=4cd8b58f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd8b58f",
  null
  
)

export default component.exports